export const countryOptions = [
    {key: 'it', value: 'it', flag: 'it', text: 'Italian'},
    {key: 'gb', value: 'en', flag: 'gb', text: 'English'}
];
